import { graphql } from 'gql.tada';

export const GET_SELLERS = graphql(`
    query searchSellers(
        $limit: Int, 
        $offset: Int, 
        $orderBy: SellerOrderBy, 
        $contactEmail: String, 
        $contactName: String, 
        $sku: Int, 
        $legalName: String
    ) {
        searchSellers(
            limit: $limit, 
            offset: $offset, 
            orderBy: $orderBy, 
            contactEmail: $contactEmail, 
            contactName: $contactName, 
            sku: $sku, 
            legalName: $legalName
        ) {            
            count
            sellers {
                identifier {
                    sku
                    id
                }
                legalName
                contactEmail
                contactName
                postalAddress
                billingEmail
                vatId
                commissionRate
                payoutTemplate
                businessProvider {
                    identifier {
                        sku
                        id
                    }
                    contactName
                }
            }
        }
    }

`);

export const GET_SELLER = graphql(`
    query seller($id: UUID!) {
        seller(id: $id) {
            identifier {
                id
                sku
            }
            legalName
            contactEmail
            contactName
            postalAddress
            billingEmail
            vatId
            walletBalance
        }
    }

`);

export const GET_SELLER_SUMMARY = graphql(`
    query sellerSummary($id: UUID!) {
        seller(id: $id) {
            identifier {
                id
            }
            legalName
            contactName
        }
    }

`);

export const UPDATE_SELLER = graphql(`
    mutation updateSeller(
        $id: String!, 
        $billingEmail: String, 
        $contactEmail: String, 
        $contactName: String, 
        $legalName: String, 
        $postalAddress: String, 
        $vatId: String
        $businessProviderId: String, 
        $commissionRate: Float, 
        $cognitoPassword: String, 
        $payoutTemplate: String, 
    ) {
        updateSeller(
            id: $id, 
            billingEmail: $billingEmail, 
            businessProviderId: $businessProviderId, 
            commissionRate: $commissionRate, 
            contactEmail: $contactEmail, 
            contactName: $contactName, 
            legalName: $legalName, 
            postalAddress: $postalAddress, 
            vatId: $vatId,
            payoutTemplate: $payoutTemplate,
            cognitoPassword: $cognitoPassword,
        ) {
            identifier {
                id
                sku
            }
            
        }
    }
`);

export const CREATE_SELLER = graphql(`
    mutation createSeller(
        $billingEmail: String!, 
        $businessProviderId: String, 
        $commissionRate: Float!, 
        $contactEmail: String!,
        $contactName: String!, 
        $legalName: String!, 
        $payoutTemplate: String!, 
        $postalAddress: String!, 
        $vatId: String!
    ) {
        createSeller(
            billingEmail: $billingEmail, 
            businessProviderId: $businessProviderId, 
            commissionRate: $commissionRate, 
            contactEmail: $contactEmail, 
            contactName: $contactName, 
            payoutTemplate: $payoutTemplate, 
            legalName: $legalName, 
            postalAddress: $postalAddress, 
            vatId: $vatId
        ) {
            identifier {
                id
                sku
            }
        }
    }
`);

export const WITHDRAW_SELLER_WALLET = graphql(`
    mutation walletWithdraw($sellerId: UUID) {
        walletWithdraw(sellerId: $sellerId)
    }
`);
